import { gsap } from 'gsap';
import { getKeyboardFocusableElements } from '../utils';
		
export default class SizeGuideModal {
	constructor(el) {
		this.el = el;

		this.openButton = document.querySelector('[data-size-guide-open-button]');
		this.closeButton = this.el.querySelector('[data-size-guide-close-button]');


		this.tableControls = this.el.querySelector('[data-table-controls]');
		this.tables = this.el.querySelectorAll('[data-table]');


		this.tableControls.addEventListener('change', e => {
			this.switchTable();
		});

		this.init();
	}



	init() {
		this.blurLayer = document.querySelector('[data-blur-layer]');
		this.modalOpen = false;

		if(this.openButton) {
			this.openButton.addEventListener('click', () => {
				this.openModal();
			});

			if(this.closeButton) {
				this.closeButton.addEventListener('click', () => {
					this.closeModal();
				});
			}

			window.addEventListener('click', (e) => {
				e.stopPropagation();
				if (e.target == this.el) {
					this.toggleModal();
				}
			});
		}

		window.addEventListener('keydown', e => {
			if (!this.el) {
				return;
			}

			if (e.key === 'Escape') {
				this.closeModal();
			}

			if (e.key === 'Tab' || e.key === 9) {
				if (e.shiftKey) {
					if (document.activeElement === this.firstElement) {
						this.lastElement.focus();
						e.preventDefault();
					}
				} else {
					if (document.activeElement === this.lastElement) {
						this.firstElement.focus();
						e.preventDefault();
					}
				}
			}

		});
	}

	get firstElement() {
		if (!this.focusableElements) {
			return null;
		}

		return this.focusableElements[0];
	}

	get lastElement() {
		if (!this.focusableElements) {
			return null;
		}

		return this.focusableElements[this.focusableElements.length - 1];
	}

	toggleModal() {
		if(this.modalOpen) {
			this.closeModal();
		} else {
			this.openModal();
		}
	}

	openModal() {
		this.modalOpen = true;

		if (this.animating) {
			return;
		}

		const tl = gsap.timeline({
			onStart: () => {
				this.animating = true;
				this.el.focus();

				document.dispatchEvent(new CustomEvent('disable-scroll'));
				this.blurLayer.classList.add('blur-layer--blurred');
			},
			onComplete: () => {
				this.animating = false;
				this.openButton?.setAttribute('aria-expanded', true);
				this.closeButton?.setAttribute('aria-expanded', true);
				this.el.style.pointerEvents = "auto";
			},
		});

		tl.to(
			this.el,
			{
				opacity: 1,
				ease: 'power2.inOut',
				duration: 0.1,
			}
		);

		this.focusableElements = getKeyboardFocusableElements(this.el);
	}

	closeModal() {
		this.modalOpen = false;

		if (this.animating) {
			return;
		}

		const tl = gsap.timeline({
			onStart: () => {
				this.animating = true;
			},
			onComplete: () => {
				document.dispatchEvent(new CustomEvent('enable-scroll'));
				this.blurLayer.classList.remove('blur-layer--blurred');
				this.animating = false;
				this.openButton?.setAttribute('aria-expanded', false);
				this.closeButton?.setAttribute('aria-expanded', false);
				this.el.style.pointerEvents = "none";
			},
		});

		tl.to(
			this.el,
			{
				opacity: 0,
				ease: 'power2.inOut',
				duration: 0.1,
			}
		);

		this.openButton.focus();
	}


	switchTable() {
		let selectedTagValue = [];

		this.tableControls.querySelectorAll('input[type="radio"]:checked').forEach(input => {
			selectedTagValue.push(input.value);
		});

		selectedTagValue = selectedTagValue.join('-');

		this.tables.forEach((table) => {
			let showTable = false;
			let tableTag = table.getAttribute('data-table-tag');

			if (tableTag === selectedTagValue) {
				showTable = true;
			}

			if(showTable) {
				table.classList.add('is-active');
			} else {
				table.classList.remove('is-active');
			}
		});
	}
}